export const NOW_TIMEFRAME = "NOW";
export const RENEWAL_TIMEFRAME = "RENEWAL";

export const FIXED_DISCOUNT_PROMOTION = "FIXED";
export const NOT_DEFINED_PROMOTION = "NOT_DEFINED";
// CouponDiscountType.PERCENT as sent by ph-api for both Recurly and PH_SUBSCRIPTION.
export const PERCENT_DISCOUNT_PROMOTION = "PERCENT";
export const FREE_TRIAL_PROMOTION = "FREE_TRIAL";
export const SINGLE_USE_DURATION = "SINGLE_USE";
export const FOREVER_DURATION = "FOREVER";

// The PH subscription service's own status string, relayed verbatim by ph-api on
// the renewal-invoice status (`subscription_status`). Lower-case snake_case, and
// deliberately NOT one of SP_STATES below: those are the platform's provider-
// agnostic states, this is the microservice's status column.
export const PAST_DUE_SUBSCRIPTION_STATUS = "past_due";
export const PENDING_SUBSCRIPTION_STATUS = "pending";

export const SP_STATES: Record<string, any> = {
  CANCELED: "CANCELED",
  CHANGING: "CHANGING",
  FUTURE: "FUTURE",
  INTRO: "INTRO",
  PAST_DUE: "PAST_DUE",
  PAUSED: "PAUSED",
  PENDING: "PENDING",
  REFUNDED: "REFUNDED",
  TERMINATED: "TERMINATED",
  TRIAL: "TRIAL",
};
